import { FC, ReactNode } from 'react';
import {
  EvaluationResultSpecific,
  Policy,
} from '@agilelab/plugin-wb-governance-common';
import { GovernanceTestOverviewPolicySimple } from './OverviewPolicySimpleVariant';
import { GovernanceTestOverviewPolicyTabs } from './OverviewPolicyTabs';

interface CommonProps {
  children?: ReactNode;
}

type ConditionalProps =
  | {
      kind: 'simple';
      policy: Policy;
      onUpdate: (code?: string) => void;
      editable: boolean;
      saving: boolean;
      handleSave: () => void;
      showSaveButton: boolean;
    }
  | {
      kind: 'tabs';
      result?: EvaluationResultSpecific;
      policy: Policy;
      infoContent?: JSX.Element;
      test?: {
        errors?: string[];
        content: string;
        name: string;
      };
    };

type Props = CommonProps & ConditionalProps;

export const GovernanceTestOverviewPolicy: FC<Props> = props => {
  switch (props.kind) {
    case 'simple':
      return <GovernanceTestOverviewPolicySimple {...props} />;
    case 'tabs':
      return <GovernanceTestOverviewPolicyTabs {...props} />;

    default:
      return <></>;
  }
};
